<div class="page-heading">
  <div>
    <div class="flex-container ion-wrap ion-align-items-center heading-container">
      @if (compData?.showH1) {
        @if (compData?.container?.title) {
          <h1 class="main-title">
            {{ compData?.container?.title | titlecase }}
          </h1>
        }
      }
      @if (!compData?.showH1) {
        @if (compData?.container?.title) {
          <div class="main-title">
            {{ compData?.container?.title | titlecase }}
          </div>
        }
      }

      @if (compData?.container?.subTitle) {
        <div class="sub-title">
          {{ compData?.container?.subTitle | titlecase }}
        </div>
      }
    </div>
  </div>
</div>
